/* eslint-disable no-restricted-globals */

import Vue from '@/system/main';

export default {
	parseSerial(item) {
		let preffix = item.preffix || '';
		const value = item.value || '';
		let suffix = item.suffix || '';

		const alert = [false, false];

		const vars = {
			'%YYYY': Vue.$moment().format('YYYY'),
			'%MM': Vue.$moment().format('MM')
		};

		Object.keys(vars).forEach((k) => {
			preffix = preffix.replace(k, vars[k]);
			suffix = suffix.replace(k, vars[k]);
		});

		if (preffix && !isNaN(preffix.charAt(preffix.length - 1))) {
			alert[0] = true;
		}

		if (suffix && !isNaN(suffix.charAt(0))) {
			alert[1] = true;
		}

		return {
			serial: preffix + value + suffix,
			alert: !!((alert[0] || alert[1]))
		};
	},
	async editSerialValue(serie, mode = 'up', quiet = true) {
		const getSerie = await Vue.$gestios.items('series').get(serie);

		if (getSerie.ok) {
			const value = getSerie.data.value;

			let newValue = (value + 1);
			if (mode === 'down') newValue = (value - 1);

			const result = await Vue.$gestios.items('series').edit({
				id: serie,
				params: {
					value: newValue
				}
			});

			if (result.ok) {
				if (!quiet) Vue.$toast.success(`Nº de serie ${mode === 'down' ? 'reducido' : 'incrementado'} a ${(newValue)}`);
				return true;
			}
		}

		Vue.$toast.error(`No se pudo modificar el valor numérico de la serie`);
		return false;
	},
	async getSerial(name) {
        const filters =  [
            {
                _ParentOperator: 'AND',
                _Operator: 'AND',
                Fields: {
                    name: {
                        type: 4,
                        string: name,
                        opt: '='
                    }
                }
            }
        ]

		const result = await Vue.$gestios.items('series').list({filters, limit: 1});

		if (result.ok) {
			return result.data[0];
		}

		return false;
	},
    async getSerialNumber(name){
        try {
            const data = await this.getSerial(name)

            if (data) {
                const serie = this.parseSerial(data).serial;

                return {
                    data: data,
                    value: serie
                }
            }

            return false;
        } catch (error) {
            console.error(error);
            return false;
        }
    }
};
